import { Empresa } from './empresa';
import { Serializable } from './commom/serializable';

export class Usuario implements Serializable<Usuario> {
    public Id: number;    
    public NomeUsuario: string;
    public CpfUsuario: string;
    public Senha: string;
    public Empresa: Empresa;
    public Perfil: string;    
    public Email: string;  
    public Ativo: string; 
    public NomeEmpresaUsuario: string;   
    public CnpjEmpresaUsuario: string;  
    public IdentificacaoLoja: string;   
    public Fone: string; 
    public DtAniversario: Date;
    public Informativo: boolean;

    deserialize(input: Object): Usuario {
        Object.assign(this, input);

        return this;
    }
}


// WEBPACK FOOTER //
// ./src/entities/usuario.ts